export const getPeriodInitialState = {
	periods: null,
	error: null,
	errorShow: false,
	loading: false,
};
